var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.model, function(item, key) {
        return _c("div", { key: key, staticClass: "row my-3" }, [
          _c(
            "div",
            {
              staticClass: "col-md col-12 d-flex align-items-center mt-4 pt-1"
            },
            [
              _c("label", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm._f("uppercase")(item.goal.name)) + ":")
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { staticClass: "data-name" }, [_vm._v("Número:")]),
              _vm.isReadOnly
                ? _c("div", [
                    _vm._v(" " + _vm._s(_vm._f("empty")(item.number)) + " ")
                  ])
                : _c("validation-provider", {
                    attrs: {
                      rules: _vm.setRulesWhenHasValue(
                        item.profession,
                        "required"
                      )
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors, failedRules }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  "custom-error-msg": _vm.getErrorMessage(
                                    failedRules
                                  ),
                                  error: errors[0]
                                },
                                model: {
                                  value: item.number,
                                  callback: function($$v) {
                                    _vm.$set(item, "number", $$v)
                                  },
                                  expression: "item.number"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("label", { staticClass: "data-name" }, [
                _vm._v("Profesión u Oficio:")
              ]),
              _vm.isReadOnly
                ? _c("div", [
                    _vm._v(" " + _vm._s(_vm._f("empty")(item.profession)) + " ")
                  ])
                : _c("validation-provider", {
                    attrs: {
                      rules: _vm.setRulesWhenHasValue(item.number, "required")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("custom-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0]
                                    },
                                    model: {
                                      value: item.profession,
                                      callback: function($$v) {
                                        _vm.$set(item, "profession", $$v)
                                      },
                                      expression: "item.profession"
                                    }
                                  }),
                                  !_vm.isReadOnly &&
                                  !item.id &&
                                  _vm.aggregable &&
                                  key !== 0
                                    ? _c("span", {
                                        staticClass:
                                          "fas fa-times-circle text-danger cursor-pointer ml-2",
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit("remove", key)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
            ],
            1
          )
        ])
      }),
      !_vm.isReadOnly && _vm.aggregable
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end mt-3" },
            [
              _c(
                "action-button",
                {
                  staticClass: "ml-2",
                  attrs: { i: "fas fa-file-plus", variant: "success" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("add")
                    }
                  }
                },
                [_vm._v(" Añadir ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }